import produce from 'immer';

import {
  CREATE_TEAM,
  CREATE_TEAM_FAILED,
  CREATE_TEAM_SUCCESS,
  GET_STAFF,
  GET_STAFF_FAILED,
  GET_STAFF_SUCCESS,
  GET_TEAM_MEMBERS,
  GET_TEAM_MEMBERS_FAILED,
  GET_TEAM_MEMBERS_SUCCESS,
  UPDATE_STATUS,
} from 'actions/teamActions';

import {
  UPDATE_USER,
  UPDATE_USER_ROLE_SUCCESS,
  UPDATE_USER_SUCCESS,
} from 'actions/userActions';

export const initialState = {
  teams: [],
  editors: [],
  managers: [],
  sales: [],
  staff: [],
  fetching: false,
  fetchSuccess: false,
  fetchFailed: false,
  statusText: null,
  submitting: false,
  createSuccess: false,
  createFailed: false,
  createError: '',
  itemId: null,
};

/* eslint-disable default-case, no-param-reassign */
const teamReducer = (state = initialState, action) =>
  // eslint-disable-next-line consistent-return
  produce(state, (draft) => {
    switch (action.type) {
      case CREATE_TEAM:
      case UPDATE_USER:
        draft.submitting = true;
        draft.createSuccess = false;
        draft.createFailed = false;
        draft.statusText = '';
        break;

      case CREATE_TEAM_SUCCESS:
        draft.submitting = false;
        draft.createSuccess = true;
        draft.createFailed = false;
        draft.statusText = '';
        break;

      case UPDATE_STATUS:
        draft.submitting = false;
        draft.statusText = '';
        draft.createSuccess = false;
        draft.createFailed = false;
        break;

      case CREATE_TEAM_FAILED:
        draft.submitting = false;
        draft.createSuccess = false;
        draft.createFailed = true;
        draft.statusText = action.err;
        draft.itemId = action.id;
        break;

      case GET_TEAM_MEMBERS:
        draft.fetching = true;
        draft.fetchSuccess = false;
        draft.fetchFailed = false;
        break;
      case GET_TEAM_MEMBERS_SUCCESS:
        draft.fetching = false;
        draft.fetchSuccess = true;
        draft.fetchFailed = false;
        draft.teams = action.teams.teams ?? [];
        draft.editors = action.teams.editors ?? [];
        draft.managers = action.teams.managers ?? [];
        draft.sales = action.teams.sales ?? [];
        break;
      case GET_TEAM_MEMBERS_FAILED:
        draft.fetching = false;
        draft.fetchSuccess = false;
        draft.fetchFailed = true;
        draft.teams = [];
        draft.editors = [];
        draft.managers = [];
        draft.sales = [];
        break;
      case GET_STAFF:
        draft.fetching = true;
        draft.fetchSuccess = false;
        draft.fetchFailed = false;
        break;
      case GET_STAFF_SUCCESS:
        draft.fetching = false;
        draft.fetchSuccess = true;
        draft.fetchFailed = false;
        draft.staff = action.teams.users;
        break;
      case GET_STAFF_FAILED:
        draft.fetching = false;
        draft.fetchSuccess = false;
        draft.fetchFailed = true;
        draft.staff = [];
        break;

      case UPDATE_USER_ROLE_SUCCESS:
      case UPDATE_USER_SUCCESS:
        draft.submitting = false;
        draft.statusText = '';
        draft.createSuccess = true;
        draft.createFailed = false;
        draft.teams = draft.teams.map((team) => {
          if (team.members.find((m) => m._id === action.user._id)) {
            return {
              ...team,
              members: team.members.map((member) =>
                member._id === action.user._id ? action.user : member
              ),
            };
          }
          return team;
        });
        break;
    }
  });

export default teamReducer;
